import { useState, useEffect } from "react";
import { Switch, RadioGroup } from "@headlessui/react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

export default function ProductFilter({ products, updateFilteredProducts }) {
  // Estado para os filtros
  const [priceRange, setPriceRange] = useState({
    min: 0,
    max: 5000,
  });
  const [onSaleOnly, setOnSaleOnly] = useState(false);

  const minProductPrice = Math.min(...products.map((product) => product.price));
  const maxProductPrice = Math.max(...products.map((product) => product.price));

  useEffect(() => {
    setPriceRange({
      min: minProductPrice - 9.99,
      max: maxProductPrice + 9.99,
    });
  }, [products, minProductPrice, maxProductPrice]);

  const handlePriceMinChange = (e) => {
    const newMin = parseFloat(e.target.value);
    setPriceRange((prev) => ({
      min: Math.min(newMin, prev.max),
      max: prev.max,
    }));
  };

  const handlePriceMaxChange = (e) => {
    const newMax = parseFloat(e.target.value);
    setPriceRange((prev) => ({
      min: prev.min,
      max: Math.max(newMax, prev.min),
    }));
  };

  useEffect(() => {
    let result = [...products];

    result = result.filter((product) => {
      return product.price >= priceRange.min && product.price <= priceRange.max;
    });

    if (onSaleOnly) {
      result = result.filter((product) => product.promotion_is_active === 1);
    }

    updateFilteredProducts(result);
  }, [priceRange, onSaleOnly, products, updateFilteredProducts]);

  const resetFilters = () => {
    setPriceRange({ min: minProductPrice, max: maxProductPrice });
    setOnSaleOnly(false);
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-md mx-[4%] md:mx-0 lg:mx-0">
      <div className="flex justify-between items-center mb-4 md:flex-col md:gap-2 lg:flex-row">
        <h2 className="text-lg font-semibold text-gray-800">Filtros</h2>
        <button
          onClick={resetFilters}
          className="text-sm text-green-600 hover:text-green-800 transition-colors">
          Limpar filtros
        </button>
      </div>


      {/* Filtro de preço */}
      <div className="mb-6 md:mb-4 lg:mb-6">
        <h3 className="text-sm font-medium text-gray-700 mb-3 md:text-base">
          Faixa de preço
        </h3>
        <Slider
          range
          min={minProductPrice}
          max={maxProductPrice}
          value={[priceRange.min, priceRange.max]}
          onChange={([min, max]) => setPriceRange({ min, max })}
          trackStyle={[{ backgroundColor: "#16a34a" }]}
          handleStyle={[
            { borderColor: "#16a34a", backgroundColor: "white" },
            { borderColor: "#16a34a", backgroundColor: "white" },
          ]}
          railStyle={{ backgroundColor: "#e5e7eb" }}
        />
        <div className="flex justify-between mt-2 text-sm text-gray-500 md:text-sm lg:text-base">
          <span className="mr-0 md:mr-2 lg:mr-0">R$ {priceRange.min.toFixed(2)}</span>
          <span>R$ {priceRange.max.toFixed(2)}</span>
        </div>
      </div>

      {/* Filtro de promoção */}
      <div className="mb-2 md:mb-2 lg:mb-6">
        <Switch.Group>
          <div className="flex justify-center items-center gap-2 md:flex-col md:items-center md:gap-2 lg:flex-row lg:gap-0">
            <Switch
              checked={onSaleOnly}
              onChange={setOnSaleOnly}
              className={`${
                onSaleOnly ? "bg-green-600" : "bg-gray-200"
              } relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
            >
              <span
                className={`${
                  onSaleOnly ? "translate-x-6" : "translate-x-1"
                } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
              />
            </Switch>
            <Switch.Label className="ml-3 text-lg text-gray-700 md:text-base md:text-center md:ml-3">
              Produtos em promoção
            </Switch.Label>
          </div>
        </Switch.Group>
      </div>
    </div>
  );
}
